import { HashRouter } from 'react-router-dom';
import { Heading, Tabs, Box, Flex } from '@radix-ui/themes';
import SubNav from '../../shared/SubNav';
import { useURLParam } from '../../lib/hooks/useURLParam';
import Branding from './components/Branding.jsx';
import Notifications from './components/Notifications.jsx';
import Sharing from './components/PublicSharing.jsx';
import { Topics, TopicsProvider } from './components/Topics.jsx';
import styles from './BoardSetup.module.css';

const TABS = {
  BRANDING: 'branding',
  NOTIFICATIONS: 'notifications',
  SHARING: 'sharing',
  TOPICS: 'topics',
};

function BoardSetupContent() {
  const navItems = [
    { id: TABS.BRANDING, label: 'Branding' },
    { id: TABS.NOTIFICATIONS, label: 'Notifications' },
    { id: TABS.SHARING, label: 'Access & Sharing' },
    { id: TABS.TOPICS, label: 'Topics' },
  ];

  const allowedTabs = navItems.map(item => item.id);

  const [getTabFromURL, setTabInURL] = useURLParam('tab', allowedTabs);
  const activeTab = getTabFromURL() || TABS.BRANDING;

  // Update URL when tab changes
  const handleTabChange = newTab => {
    setTabInURL(newTab);
  };

  return (
    <TopicsProvider>
      <Flex direction="column" maxWidth="1400px" m="5" gap="5">
        <Flex height="42px" justify="between" align="center">
          <Heading size="6" m="0">
            Board Settings
          </Heading>
          {activeTab === TABS.TOPICS && <Topics.CreateButton />}
        </Flex>
        <Tabs.Root value={activeTab} onValueChange={handleTabChange}>
          <Flex>
            <SubNav
              navItems={navItems}
              currentValue={activeTab}
              onValueChange={handleTabChange}
            />
            <Box className={styles.contentContainer}>
              <Tabs.Content value={TABS.BRANDING}>
                <Branding />
              </Tabs.Content>
              <Tabs.Content value={TABS.NOTIFICATIONS}>
                <Notifications />
              </Tabs.Content>
              <Tabs.Content value={TABS.SHARING}>
                <Sharing />
              </Tabs.Content>
              <Tabs.Content value={TABS.TOPICS}>
                <Topics />
              </Tabs.Content>
            </Box>
          </Flex>
        </Tabs.Root>
      </Flex>
    </TopicsProvider>
  );
}

const BoardSetup = () => {
  return (
    <HashRouter hashType="noslash">
      <BoardSetupContent />
    </HashRouter>
  );
};

export default BoardSetup;
